import {BaseOptions} from '../../../../dialog/options/base.options';

export class AddOrUpdateTagOptions extends BaseOptions {
  tag?: any;

  onInsertOrUpdateFinished() {
  }
}
